import { Loading } from 'JBSrc/constants';
import { carouselList } from 'JBSrc/carousel';
import { scrollTo } from 'JBPlugin/scroll-to';

(function($) {
	const eventSearch = $('.event-search-form');
	if(eventSearch.length){
		eventSearch.submit(function(e){
			e.preventDefault();
			let form = $(this);
			let formData = new FormData(this);
			let container = $(this).data('container');
			$(container).html(Loading.default);

			$.ajax({
				url: form.attr('action'),
				type: 'POST',
				data: formData,
				success: function (data) {
					$(container).html(data);
					$('.js-filter-category-toggle').removeClass('open');
					$('.filter__mobile-toggle').removeClass('open');
					scrollTo('#searched-events');
					carouselList();
				},
				error: function(){
					$(container).html('');
				},
				cache: false,
				contentType: false,
				processData: false
			});
		});
	}
})(jQuery);
